/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:a4bbd98d-512b-456b-b8a7-cc9d02a2fffe",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_KQ9GjZAjV",
    "aws_user_pools_web_client_id": "71d4l5l49ee6q10rvj0lp909vf",
    "oauth": {
        "domain": "d-ns-studio-dev-prod.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://d-ns-poc.s3.amazonaws.com/",
        "redirectSignOut": "https://d-ns-poc.s3.amazonaws.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_mobile_analytics_app_id": "36c3e197f76f406a9d56c43340fd3016",
    "aws_mobile_analytics_app_region": "us-east-1"
};


export default awsmobile;
